<template>
  <div class="section_body">
    <div class="section_title">
        <h2>Information</h2>
        <span class="date">{{ moment(new Date()).format('MMM Do YYYY') }}</span>
    </div>
    <div class="negetive_margin" >
        <div class="md-layout md-alignment-bottom-center">
            <div class="md-layout-item md-size-40">
                <div class="table_sec change-sec mt-4">
                  <div class="tbl-title"><p>Industry Peer Group</p></div>
                    <md-table v-model="tableDataFirmsAnalyzed">
                    <md-table-row
                    slot="md-table-row"
                    slot-scope="{ item }"
                    >
                    <md-table-cell
                    md-label="Profile Year"
                    md-sort-by="year"
                    >
                    {{ item.year }}
                    </md-table-cell>
                    <md-table-cell md-label="Firms">
                    {{ item.firms }}
                    </md-table-cell>
                    </md-table-row>
                    </md-table>
                </div>
            </div>
              <div class="md-layout-item md-size-60 mt-4">
                  <div v-if="chartInfo && chartInfo !== {} && chartInfo.colouredLineChart && chartInfo.colouredLineChart.data.series[0]">
                  <BarChart :categories="chartInfo.colouredLineChart.data.labels" :chartdata="chartData" :legend="true" />

                </div>
            </div>
            <div class="md-layout-item md-medium-size-100 md-size-100 mt-4 pt-4 mb-4">
                <div class="tbl-title"><h4>Your Industry In Context: The NAICS Classification System</h4></div>
                <div class="white_space p-4">
                    <p class="px-4">
                        The industry your selected fits within the official
                        NAICS (North American Industry Classification
                        System) and Bizminer’s proprietary taxonomy, which
                        breaks out more detailed industries classifications
                        than NAICS by adding up to eight decimal digits
                        after the NAICS-6 code. The industry you selected
                        fits into this industry hierarchy:
                    </p>
                    <ul>
                        <li
                        v-for="(value, key) in naicsDrilldown"
                        :key="key"
                        >
                        NAICS: {{ key }} - {{ value }}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { TableCard, ProfileCard } from '@/components';
import BarChart from '@/components/BarChart.vue';
import { mapState } from 'vuex';
import formatData from '@/mixins/format-data';
import moment from 'moment'
export default {
  components: {
    // ChartCard,
    BarChart
  },
  mixins: [formatData],
  props: ['headerData', 'information'],
  data() {
    return {
      colouredLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          // lineSmooth: this.$Chartist.Interpolation.cardinal({
          //   tension: 10,
          // }),
          axisY: {
            showGrid: true,
            offset: 40,
          },
          axisX: {
            showGrid: false,
          },
          low: 0,
          showPoint: true,
          height: '300px',
        },
      },
      tableDataFirmsAnalyzed: [],
      moment: moment,
      loading: false,
      naicsDrilldown: {},
      filtered_years: [],
      filtered_firms: [],
      filtered_PLDollar: [],
      filtered_PLPercent: [],
      filtered_BSDollar: [],
      filtered_BSPercent: [],
      cashflow: [],
      cashFlowFilteredData: [],
      efficiency: [],
      efficiencyFilteredData: [],
      profitability: [],
      profitabilityFilteredData: [],
      turnover: [],
      debtRiskFilteredData: [],
      changein: [],
      changeinFilteredData: [],
      worksheet: [],
      worksheetFilteredData: [],
      sales_class_csv: '',
      chartInfo: false,
    };
  },
  computed: {
    ...mapState({
      spif: (state) => state.user.profile.spif,
      data: (state) => state.user.profile.data,
      profile: (state) => state.user.profile,
      PLtable: (state) =>
        state.user.profile.tables
          ? state.user.profile.tables['PL']
          : state.user.profile.data.tables['PL'],
      BStable: (state) =>
        state.user.profile.tables
          ? state.user.profile.tables['BS']
          : state.user.profile.data.tables['BS'],
      tables: (state) =>
        state.user.profile.tables
          ? state.user.profile.tables['ratios']
          : state.user.profile.data.tables['ratios'],
      tablesInfo: (state) =>
        state.user.profile.tables
          ? state.user.profile.tables['ratioInfo']
          : state.user.profile.data.tables['ratioInfo'],
      sourcesUses: (state) =>
        state.user.profile['sourcesUses']
          ? state.user.profile['sourcesUses']
          : state.user.profile.data['sourcesUses'],
      sourceYears: (state) =>
        state.user.profile['sourcesUses']
          ? state.user.profile['sourcesUses']['years']
          : state.user.profile.data['sourcesUses']['years'],
      release_display: (state) =>
        state.user.profile.data.data.data[0].release_display,
      bznaics_code: (state) => state.user.profile.data.data.data[0].bznaics,
      sector_name: (state) =>
        state.user.profile.data.data.data[0]
          ? state.user.profile.data.data.data[0].sector
          : '',
      industry_title: (state) =>
        state.user.profile.data.data.data[0]
          ? state.user.profile.data.data.data[0].industry
          : '',
      sales_class: (state) =>
        state.user.profile.data.data.data[0]
          ? state.user.profile.data.data.data[0].sales_class
          : '',
      display_area: (state) =>
        state.user.profile.data.data.data[0]
          ? state.user.profile.data.data.data[0].display_area
          : '',
    }),
    sourceTablesInfo() {
      return _.omit(this.sourcesUses, 'years');
    },
    filteredProfile() {
      return Object.values(this.profile.data.data.data).filter((item) => item);
    },
    filteredData() {
      return Object.values(this.data).filter((item) => item);
    },
    actualData() {
      return this.filteredData[0]['cashflow'];
    },
    chartData() {
        return [{
            name: 'series-1',
            data: this.reverseArray(this.chartInfo.colouredLineChart.data.series[0])
        }];
    },
  },
  mounted() {
    this.initData();
  },
  methods: {
    reverseArray(a) {
        var rA = []
        for (var i = a.length; i > 0; i--) {
            rA.push(a[i - 1])
        }

        return rA;
    },
    initData() {
      if (!this.data) {
        return;
      }

      this.data.years.forEach((e, i) => {
        this.filtered_years.push(Number(e));
      });

      this.tableDataFirmsAnalyzed = Object.values(this.profile.data.data.data)
        .filter((item) => item)
        .map((item) => ({ ...item, firms: this.numberWithCommas(item.firms) }));
      this.tableDataFirmsAnalyzed = _.orderBy(
        this.tableDataFirmsAnalyzed,
        ['year'],
        ['asc']
      );

      this.naicsDrilldown = this.profile.data.naicsDrilldown;
      this.colouredLineChart.data = {
        labels: this.profile.data.years,
        series: [this.filteredProfile.map((item) => item.firms)],
      };

      let firmData = Object.values(this.data)
        .filter((item) => item)
        .map((item) => ({ ...item, firms: item.firms }));
      firmData.forEach((element) => {
        this.filtered_firms.push(parseFloat(element.firms));
      });

      let PLdollar = this.formatTable(this.PLtable, 'industry', 'dollar');
      let PLpercent = this.formatTable(this.PLtable, 'industry', 'percent');

      PLdollar.forEach((element) => {
        if (element.name.includes(',')) {
          element.name = element.name.replace(/,/g, '');
        }
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (typeof e === 'string' && e.includes(',')) {
            e = parseFloat(e.replace(/,/g, ''));
          }
          v.push(e);
        });
        v.unshift(element.name);
        this.filtered_PLDollar.push(v);
      });
      PLpercent.forEach((element) => {
        if (element.name.includes(',')) {
          element.name = element.name.replace(/,/g, '');
        }
        let z = Object.values(element.dates);
        let v = [];
        z.forEach((item, i) => {
          if (typeof item === 'string' && item.includes(',')) {
            item = parseFloat(item.replace(/,/g, ''));
          }
          v.push(item);
        });
        v.unshift(element.name);
        this.filtered_PLPercent.push(v);
      });

      let BSdollar = this.formatTable(this.BStable, 'industry', 'dollar');
      let BSpercent = this.formatTable(this.BStable, 'industry', 'percent');

      BSdollar.forEach((element) => {
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (typeof e === 'string' && e.includes(',')) {
            e = parseFloat(e.replace(/,/g, ''));
          }
          v.push(e);
        });

        v.unshift(element.name);
        this.filtered_BSDollar.push(v);
      });
      BSpercent.forEach((element) => {
        let z = Object.values(element.dates);
        let v = [];
        z.forEach((item, i) => {
          if (typeof item === 'string' && item.includes(',')) {
            item = parseFloat(item.replace(/,/g, ''));
          }
          v.push(item);
        });
        v.unshift(element.name);
        this.filtered_BSPercent.push(v);
      });

      let cashFlowData = [];
      this.cashflow.forEach((element, index) => {
        if (element.name in this.tables['cashflow']) {
          cashFlowData.push({
            dates: element.dates,
            title: this.tablesInfo[element.name]['title'],
          });
        }
      });
      cashFlowData.forEach((element) => {
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (typeof e === 'string' && e.includes(',')) {
            e = parseFloat(e.replace(/,/g, ''));
          }
          v.push(e);
        });

        v.unshift(element.title);
        this.cashFlowFilteredData.push(v);
      });

      let efficiencyData = [];
      this.efficiency.forEach((element, index) => {
        if (element.name in this.tables['efficiency']) {
          efficiencyData.push({
            dates: element.dates,
            title: this.tablesInfo[element.name]['title'],
          });
        }
      });
      efficiencyData.forEach((element) => {
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (typeof e === 'string' && e.includes(',')) {
            e = parseFloat(e.replace(/,/g, ''));
          }
          v.push(e);
        });

        v.unshift(element.title);
        this.efficiencyFilteredData.push(v);
      });

      let profitabilityData = [];
      this.profitability.forEach((element, index) => {
        if (element.name in this.tables['profitability']) {
          profitabilityData.push({
            dates: element.dates,
            title: this.tablesInfo[element.name]['title'],
          });
        }
      });
      profitabilityData.forEach((element) => {
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (typeof e === 'string' && e.includes(',')) {
            e = parseFloat(e.replace(/,/g, ''));
          }
          v.push(e);
        });

        v.unshift(element.title);
        this.profitabilityFilteredData.push(v);
      });

      let debtRiskData = [];
      this.turnover.forEach((element, index) => {
        if (element.name in this.tables['turnover']) {
          debtRiskData.push({
            dates: element.dates,
            title: this.tablesInfo[element.name]['title'],
          });
        }
      });
      debtRiskData.forEach((element) => {
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (typeof e === 'string' && e.includes(',')) {
            e = parseFloat(e.replace(/,/g, ''));
          }
          v.push(e);
        });

        v.unshift(element.title);
        this.debtRiskFilteredData.push(v);
      });

      Object.entries(this.sourceTablesInfo).forEach(([table, data]) =>
        this.$set(this, table, this.formatSourcesData(table, data))
      );

      this.changein.forEach((element, index) => {
        let k = [];
        Object.values(element.dates).forEach((e, index) => {
          k.push(e);
        });
        k.unshift(element.title);
        this.changeinFilteredData.push(k);
      });
      this.worksheet.forEach((element, index) => {
        let k = [];
        Object.values(element.dates).forEach((e, index) => {
          k.push(e);
        });
        k.unshift(element.title);
        this.worksheetFilteredData.push(k);
      });
    },
    numberWithCommas(x) {
      if (x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      } else {
        return x;
      }
    },
    formatSourcesData(table, data) {
      let getDates = (id) =>
        this.sourceYears.reduce((acc, cur, index) => {
          let value = this.actualData[this.sourceYears.length - index - 1][id];

          value = isNaN(Number(value)) ? value : Number(value.toFixed(0));

          return { ...acc, [cur]: value };
        }, {});

      return data.map((item) => ({
        ...item,
        dates: getDates(item.id),
      }));
    },
  },
   watch: {
     profile(newVal, oldVal) {
      // this.init();
      this.initData();
    },
    information: function(newVal, oldVal) { // watch it
            this.chartLoaded = true;
            this.chartInfo = newVal;
        }
    },
};
</script>
<style lang="scss">
.introduction-body {
  display: flex;
  align-items: flex-start;
}

.introduction-title {
  display: flex;
  flex-direction: column;
  justify-content: end;
}

.loading {
  position: absolute;
  left: 45%;
  // left: calc(45% / 2);
}
</style>
